import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import isEqual from 'react-fast-compare';

import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import {
    getItemSummaryCatalogId,
    getItemSummaryImageVersion,
    getItemSummaryPhotos,
    getItemSummarySellerId,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getItemCardImageUrl, getStoreFrontUrl, logoUrl } from '@/utils/urls';

type Props = {
    firstItemId: number;
    itemCount: number;
    sellerId: number;
};

const StorefrontPageHeaderMeta = ({ firstItemId, itemCount, sellerId }: Props) => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, firstItemId));
    const imageVersion = useAppSelector((state) => getItemSummaryImageVersion(state, firstItemId));
    const photos = useAppSelector((state) => getItemSummaryPhotos(state, firstItemId));
    const houseId = useAppSelector((state) => getItemSummarySellerId(state, firstItemId));

    const title = useAddNotificationCountToTitle(formatMessage({ id: 'sf_meta_title' }, { sellerId }));
    const description = formatMessage({ id: 'sf_meta_description' }, { itemCount });
    const canonical = `${baseUrl}${getStoreFrontUrl(sellerId)}`;
    const firstPhoto = photos?.[0] || 0;

    const imageUrl = getItemCardImageUrl(houseId, catalogId, firstItemId, firstPhoto, imageVersion) || logoUrl;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            imageUrl={imageUrl}
            title={title}
        />
    );
};

export default React.memo<Props>(StorefrontPageHeaderMeta, isEqual);
